import React, { useEffect, useState } from 'react'
import { Dropdown, Pagination } from 'react-bootstrap'
import './DashboardHome.css';
import { Search } from 'react-bootstrap-icons';
import { BiSolidChevronRightCircle } from 'react-icons/bi';
import TaskModal from '../components/TaskModal/TaskModal';
import TaskDetailsModal from '../components/TaskDetailsModal/TaskDetailsModal';
import Task1 from '../../../assets/images/task1.png';
import Task2 from '../../../assets/images/task2.png';
import Task3 from '../../../assets/images/task3.png';
import Task4 from '../../../assets/images/task4.png';
import Task5 from '../../../assets/images/task5.png';
import { IoEye, IoEyeOutline, IoPencil, IoPencilOutline } from 'react-icons/io5';
import { useDispatch, useSelector } from 'react-redux';
import { getAllTaskPriorities, getAllTasks, getAllTaskStatuses, getAllTaskTypes, getDashboardSummary, getSingleTask } from '../../../redux/TaskReducer/action';
import { getTabsFromSubtasks, PRIORITY_FILTERS, STATUS_FILTERS } from '../../../utils/taskUtils';
import { getTimeAgo } from '../../../utils/dateTimeUtils';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const DashboardHome = () => {
    const tasksList = [
        { text: "Create a user flow of social application design", done: true },
        { text: "Create a user flow of social application design", done: true },
        { text: "Landing page design for Fintech project of singapore", done: true },
        { text: "Interactive prototype for app screens of deltamine project", done: false },
    ];

    const { taskStatuses, taskPriorities, tasks, dashboardSummary } = useSelector((store) => {
        return {
            taskStatuses: store.TasksReducer.taskStatuses,
            taskPriorities: store.TasksReducer.taskPriorities,
            tasks: store.TasksReducer.tasks,
            dashboardSummary: store.TasksReducer.dashboardSummary
        }
    });

    const stats = [
        { 
            label: "Total Task", 
            value: dashboardSummary?.total_task ?? 0, 
            icon: Task5,
            accent: "kpi-total"
        },
        { 
            label: "Open Task", 
            value: dashboardSummary?.backlog ?? 0, 
            icon: Task2,
            accent: "kpi-open"
        },
        { 
            label: "In Progress", 
            value: dashboardSummary?.in_progress ?? 0, 
            icon: Task1,
            accent: "kpi-inprogress"
        },
        { 
            label: "Completed", 
            value: dashboardSummary?.completed ?? 0, 
            icon: Task4,
            accent: "kpi-completed"
        },
        { 
            label: "To Do", 
            value: dashboardSummary?.todo ?? 0, 
            icon: Task3,
            accent: "kpi-todo"
        },
        { 
            label: "Awaiting Review", 
            value: dashboardSummary?.review ?? 0, 
            icon: Task3,
            accent: "kpi-review"
        }
    ];

    const [showTaskModal, setShowTaskModal] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedPriority, setSelectedPriority] = useState(null);
    const [globalSearch, setGlobalSearch] = useState("");

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const totalPages = tasks?.pagination?.total_pages;

    const navigate = useNavigate();

    const [taskFilters, setTaskFilters] = useState({
        task_id: "",
        readable_task_id: "",
        priority_id: "",
        status_id: "",
        seeds_id: "",
        emp_id: "",
        global_search: "",
        title: "",
        assigned_to: "",
        created_by: "",
        application_id: "",
        is_active: true,
        designation: "ALL"
    })

    // QMS Tab — Query Visibility Across RO, BM and BCM: labels for the designation filter.
    // "All" is the default (matches /task/get-all-tasks's own default), the rest narrow the
    // list to tasks that have a query assigned to that officer type.
    const DESIGNATION_FILTER_OPTIONS = [
        { code: "ALL", label: "All Designations" },
        { code: "RO", label: "RO" },
        { code: "BM", label: "BM" },
        { code: "BCM", label: "BCM" },
    ];
    const [selectedDesignation, setSelectedDesignation] = useState("ALL");

    const [taskPriorityFilters, setTaskPriorityFilters] = useState(PRIORITY_FILTERS)
    const [taskStatusFilters, setTaskStatusFilters] = useState(STATUS_FILTERS)
    const [isRestored, setIsRestored] = useState(false);

    const [actionPopupIndex, setActionPopupIndex] = useState(null);
    const dispatch = useDispatch();

    const { singleTask } = useSelector((store) => {
        return {
            singleTask: store.TasksReducer?.singleTask
        };
    })

    const [pendingTaskId, setPendingTaskId] = useState(null);

    const handleOutsideClick = (e) => {
        if (!e.target.closest(".action-popup")) {
            setActionPopupIndex(null);
        }
    };

    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    useEffect(() => {
        dispatch(getAllTaskStatuses(taskStatusFilters));
        dispatch(getAllTaskPriorities(taskPriorityFilters));
        dispatch(getDashboardSummary())
    }, []);


    useEffect(() => {
        const saved = sessionStorage.getItem("taskDashboardState");

        if (saved) {
            const state = JSON.parse(saved);

            setCurrentPage(state.currentPage || 1);
            setLimit(state.limit || 10);
            setTaskFilters(state.taskFilters || {});
            setGlobalSearch(state.globalSearch || "");
            setSelectedStatus(state.selectedStatus || null);
            setSelectedPriority(state.selectedPriority || null);
            setSelectedDesignation(state.selectedDesignation || "ALL");
        }

        setIsRestored(true);
    }, []);

    useEffect(() => {
        if (!isRestored) return;

        sessionStorage.setItem(
            "taskDashboardState",
            JSON.stringify({
                currentPage,
                limit,
                taskFilters,
                globalSearch,
                selectedStatus,
                selectedPriority,
                selectedDesignation
            })
        );
    }, [currentPage, limit, taskFilters, globalSearch, selectedStatus, selectedPriority, selectedDesignation, isRestored]);

    const handlePageChange = (newPage) => {
        // Ensure we're working with 1-based pagination
        const pageToSet = Math.max(1, Math.min(newPage, totalPages));
        setCurrentPage(pageToSet);
        sessionStorage.setItem('currentPage', pageToSet.toString());
    };
    
    useEffect(()=> {
        if (!isRestored) return;

        dispatch(getAllTasks(currentPage, limit, taskFilters));
    }, [currentPage, limit, taskFilters, isRestored]);

    const taskData = {
        taskId: "TSK-001",
        caseId: "APP-2025-001",
        priority: "HIGH",
        status: "DONE",
        category: "KYC Verification", // Or "Image Update", "KYC Verification"
        type: "Document Collection",
        subtype: "Incorrect Spelling",
        targetDate: "Oct 20, 2025",
        remarks: "The name present in KYC is incorrect",
        assignedTo: "Rahul Kumar",
        createdBy: "Sushmit",
        createdAt: "Oct 17, 2025 10:30",
        updatedAt: "Oct 17, 2025 10:30",
    };

    

    const getPaginationItems = (currentPage, totalPages) => {
        const items = [];
        const pageRange = 2;

        // Prev
        items.push(
            <Pagination.Prev
                key="prev"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
            />
        );

        // First page
        items.push(
            <Pagination.Item
                key={1}
                active={currentPage === 1}
                onClick={() => setCurrentPage(1)}
            >
                1
            </Pagination.Item>
        );

        // Left ellipsis
        if (currentPage > pageRange + 2) {
            items.push(<Pagination.Ellipsis key="left-ellipsis" disabled />);
        }

        // Middle pages
        const start = Math.max(2, currentPage - pageRange);
        const end = Math.min(totalPages - 1, currentPage + pageRange);

        for (let i = start; i <= end; i++) {
            items.push(
                <Pagination.Item
                    key={i}
                    active={currentPage === i}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }

        // Right ellipsis
        if (currentPage < totalPages - (pageRange + 1)) {
            items.push(<Pagination.Ellipsis key="right-ellipsis" disabled />);
        }

        // Last page
        if (totalPages > 1) {
            items.push(
                <Pagination.Item
                    key={totalPages}
                    active={currentPage === totalPages}
                    onClick={() => setCurrentPage(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        // Next
        items.push(
            <Pagination.Next
                key="next"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
            />
        );

        return items;
    };

    useEffect(() => {
        if (!pendingTaskId || !singleTask?.data) return;
        // if (!pendingTaskId || !selectedTask) return;

        if (singleTask.data.task_id !== pendingTaskId) return;

        const subTasks = singleTask.data.sub_tasks || [];
        console.log({ singleApp: singleTask?.data });

        if (subTasks.length === 0) {
            navigate(
            `/task-management/${pendingTaskId}/${singleTask?.data?.category_id}/create-subtask`
            );
        } else {
            const tabs = getTabsFromSubtasks(subTasks);

            navigate(
            `/task-management/${pendingTaskId}/subtask-verification/${tabs[0].code}`
            );
        }

        setPendingTaskId(null);
    }, [singleTask, pendingTaskId, navigate]);

    return (
        <div className='task-home-container'>
            <div className='dashboard-stats'>
                <div className='stat-cards'>
                    {stats?.map((item, i) => (
                        <div key={i} className={`taskKpiCard ${item.accent}`}>
                            <div className="taskKpiText">
                                <span className="taskKpiLabel">{item.label}</span>
                                <span className="taskKpiValue">{item.value}</span>
                            </div>
                            <div className="taskKpiIcon">
                                <img src={item.icon} alt="icon" />
                            </div>
                        </div>
                    ))}
                </div>
                <div className='task-section'>
                    <h5 className="task-title">Recent Updates</h5>

                    {/* <Nav variant="tabs" defaultActiveKey="important" className="task-tabs">
                        <Nav.Item>
                            <Nav.Link eventKey="all">
                                All <span className="tab-pill">10</span>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="important">
                                Important <span className="tab-active-line"></span>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="notes">
                                Notes <span className="tab-pill">05</span>
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="links">
                                Links <span className="tab-pill">10</span>
                            </Nav.Link>
                        </Nav.Item>
                    </Nav> */}

                    <div className="task-list">
                        {/* {tasksList.map((t, i) => (
                            <div className="task-item" key={i}>
                                <span className={`task-check ${t.done ? "done" : ""}`}>
                                    {
                                        t.done ?
                                            <CheckCircleFill style={{ fill: "green" }} /> :
                                            <Circle />
                                    }
                                </span>
                                <span className="task-text">{t.text}</span>
                            </div>
                        ))} */}

                        {
                            dashboardSummary?.recent_updated_tasks?.sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))?.slice(0, 3)?.map((update) => {
                                return (
                                    <div className="task-item" key={update?.readable_task_id}>
                                        {/* <div className='task-icon'>

                                        </div> */}
                                        <div className='task-item-content'>
                                            <span>{update.title}</span>
                                            <span className="readable-task-id">{update.readable_task_id}</span>
                                        </div>
                                        <div className='task-update-duration'>
                                            {getTimeAgo(update.updated_at)}
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className='view-updates-section'>
                        <span 
                            onClick={() => {
                                navigate("/task-management/recent-updates");
                            }}
                        >
                            View All Updates
                        </span>
                    </div>
                </div>
            </div>
            <div className='tabular-view'>
                <div className='table-top-section'>
                    <div className='search-section'>
                        {/* Search */}
                        <div className="taskSearchInputWrapper">
                            <Search className="taskSearchIcon" />
                            <input
                                type="text"
                                value={globalSearch}
                                placeholder="Search by application name or case id..."
                                onChange={(e) => {
                                    let inputValue = e.target.value;
                                    if (typeof inputValue === 'string') {
                                        inputValue = inputValue.replace(/[\t\n\r]+/g, '').replace(/^\s+/, '');
                                    }
                                    if(inputValue === ''){
                                        setTaskFilters(prev => ({
                                            ...prev,
                                            global_search: inputValue
                                        }))
                                    }
                                    setGlobalSearch(inputValue)
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        setTaskFilters(prev => ({
                                            ...prev,
                                            global_search: globalSearch
                                        }))
                                        handlePageChange(1);
                                    }
                                }}
                            />
                        </div>

                        <button
                            className="search-btn"
                            onClick={() => {
                                setTaskFilters(prev => ({
                                    ...prev,
                                    global_search: globalSearch
                                }))

                                handlePageChange(1);
                            }}
                        >
                            Search
                        </button>
                    </div>

                    <div className='filter-section'>
                        <Dropdown>
                            <Dropdown.Toggle className="search-btn">
                                {DESIGNATION_FILTER_OPTIONS.find(o => o.code === selectedDesignation)?.label || "All Designations"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {DESIGNATION_FILTER_OPTIONS.map((option) => (
                                    <Dropdown.Item
                                        key={option.code}
                                        onClick={() => {
                                            setSelectedDesignation(option.code);
                                            setTaskFilters(prev => ({
                                                ...prev,
                                                designation: option.code
                                            }));

                                            handlePageChange(1);
                                        }}
                                    >
                                        {option.label}
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle className="search-btn">
                                {/* All Status */}
                                {selectedStatus ? selectedStatus.status_name : "Status"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {/* RESET / SHOW ALL */}
                                <Dropdown.Item
                                    onClick={() => {
                                        setSelectedStatus(null);
                                        setTaskFilters(prev => ({
                                            ...prev,
                                            status_id: "",
                                            status_code: "",
                                            status_name: "",
                                            status: ""
                                        }));

                                        handlePageChange(1);
                                    }}
                                >
                                    All
                                </Dropdown.Item>
                                {
                                    taskStatuses?.filter((status) => {
                                        const sName = (status.status_name || "").toLowerCase();
                                        const sCode = (status.status_code || "").toLowerCase();
                                        return !sName.includes("approved") &&
                                               !sName.includes("rejected") &&
                                               !sName.includes("approve") &&
                                               !sName.includes("reject") &&
                                               !sCode.includes("approved") &&
                                               !sCode.includes("rejected") &&
                                               !sCode.includes("approve") &&
                                               !sCode.includes("reject");
                                    }).map((status) => (
                                        <Dropdown.Item
                                            key={status.status_id}
                                            onClick={() => {
                                                setSelectedStatus(status);
                                                setTaskFilters(prev => ({
                                                    ...prev,
                                                    status_id: status.status_id,
                                                    status_code: status.status_code || "",
                                                    status_name: status.status_name || "",
                                                    status: status.status_code || status.status_name || ""
                                                }));

                                                handlePageChange(1);
                                            }}
                                        >
                                            {status.status_name}
                                        </Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>

                        <Dropdown>
                            <Dropdown.Toggle className="search-btn">
                                {/* Priority */}
                                {selectedPriority ? selectedPriority.priority_name : "Priority"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {/* RESET / SHOW ALL */}
                                <Dropdown.Item
                                    onClick={() => {
                                        setSelectedPriority(null);
                                        setTaskFilters(prev => ({
                                            ...prev,
                                            priority_id: "",
                                            priority_code: "",
                                            priority_name: "",
                                            priority: ""
                                        }));

                                        handlePageChange(1);
                                    }}
                                >
                                    All
                                </Dropdown.Item>
                                {
                                    taskPriorities?.map((priority) => (
                                        <Dropdown.Item
                                            key={priority.priority_id}
                                            onClick={() => {
                                                setSelectedPriority(priority);
                                                setTaskFilters(prev => ({
                                                    ...prev,
                                                    priority_id: priority.priority_id,
                                                    priority_code: priority.priority_code || "",
                                                    priority_name: priority.priority_name || "",
                                                    priority: priority.priority_code || priority.priority_name || ""
                                                }));

                                                handlePageChange(1);
                                            }}
                                        >
                                            {priority.priority_name}
                                        </Dropdown.Item>
                                    ))
                                }
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>

                <div className='table-container'>
                    <table className="task-table">
                        <thead>
                            <tr>
                                <th>Task ID</th>
                                <th>Case ID</th>
                                <th>Task Type</th>
                                <th>Application Name</th>
                                <th>Priority</th>
                                <th>Status</th>
                                <th>Due Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {tasks?.data?.map((task, index) => (
                                <tr key={index}>
                                    <td
                                        // onClick={() => {
                                        //     // setShowTaskModal(true);
                                        //     setSelectedTask(task);
                                        //     navigate(`/task-management/${task?.task_id}/subtask-verification`)
                                        // }}

                                        onClick={() => {
                                            // if (task?.total_subtasks === 0) {
                                            //     toast.info("No subtasks found");
                                            //     return;
                                            // }

                                            const selection = window.getSelection().toString();
                                            console.log({selection})
                                            
                                            // Prevent navigation while selecting/copying text
                                            if (selection.length > 0) return;

                                            setPendingTaskId(task.task_id);
                                            setSelectedTask(task);
                                            dispatch(getSingleTask(task.task_id));
                                        }}
                                    >{task.readable_task_id}</td>
                                    <td>{task?.application?.seeds_id}</td>
                                    <td>{task?.task_type?.type_code}</td>
                                    <td>{`${task?.application?.first_name}${task?.application?.middle_name ? ` ${task?.application?.middle_name}` : ""}${task?.application?.last_name ? ` ${task?.application?.last_name}` : ""}`}</td>
                                    <td>
                                        <span className={`pill priority-${task.priority?.priority_name?.toLowerCase()}`}>
                                            {task.priority?.priority_name}
                                        </span>
                                    </td>

                                    <td>
                                        <span className={`pill status-${task?.status?.status_code?.toLowerCase()}`}>
                                            {task?.status?.status_name?.toUpperCase()}
                                        </span>
                                    </td>

                                    <td>{task.due_date?.split('T')?.[0]}</td>

                                    <td>
                                        {/* <button className="action-btn"> */}
                                        <BiSolidChevronRightCircle
                                            size={24}
                                            fill="var(--border-color)"
                                            onClick={(e) => {
                                                e.stopPropagation();       // prevent closing immediately
                                                setActionPopupIndex(index);
                                            }}
                                            style={{ cursor: "pointer" }}
                                        />
                                        {/* </button> */}
                                        {actionPopupIndex === index && (
                                            <div className="action-popup">
                                                <button 
                                                    className="view-btn"
                                                    // onClick={() => {
                                                    //     if(task?.total_subtasks != 0){
                                                    //         navigate(`/task-management/${task?.task_id}/subtask-verification`)
                                                    //     }
                                                    //     else{
                                                    //         toast.info(`No subtasks found`);
                                                    //     }
                                                    // }}

                                                    onClick={() => {
                                                        // if (task?.total_subtasks === 0) {
                                                        //     toast.info("No subtasks found");
                                                        //     return;
                                                        // }

                                                        setPendingTaskId(task.task_id);
                                                        setSelectedTask(task);
                                                        dispatch(getSingleTask(task.task_id));
                                                    }}
                                                >
                                                    <IoEyeOutline /> View
                                                </button>

                                                {/* <button className="edit-btn">
                                                    <IoPencilOutline /> Edit
                                                </button> */}
                                            </div>
                                        )}
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {
                    showTaskModal &&
                    <TaskDetailsModal
                        show={showTaskModal}
                        onHide={() => setShowTaskModal(false)}
                        taskData={taskData}
                    />
                }

                {/* <div className='table-pagination'>

            </div> */}

                {/* Pagination */}
                <div className="pagination-wrapper">
                    <Pagination className="custom-pagination">{getPaginationItems(currentPage, totalPages)}</Pagination>
                </div>
            </div>
        </div>
    )
}

export default DashboardHome